import { components, SingleValueProps } from 'react-select'

import { SizeOptions } from '../../../../types/types'
import { AstraParagraph } from '../../../Typography/AstraParagraph/AstraParagraph'
import { SelectOption, SelectOptionGroup } from '../types'
import { typographyStyles } from '../utils/styles'

export const singleValueClassName = () => '!m-0 text-default truncate'

export function CustomSingleValue<T>(props: SingleValueProps<SelectOption<T>, false, SelectOptionGroup<T>> & { size: SizeOptions }) {
    const { data, size } = props
    return (
        <components.SingleValue {...props}>
            <AstraParagraph variant={typographyStyles[size]} weight="regular" className="truncate text-inherit">
                {data.label}
            </AstraParagraph>
        </components.SingleValue>
    )
}
